export default __webpack_public_path__ + "static/okolice_wroc_cover-484db59933da8f6e71dc8c265da41528.jpg";